import { RefundCase } from './refunds.interface';

export interface RefundsState {
  refunds: RefundCase[];
  status: RefundsStatus;
}

export enum RefundsStatus {
  INITIAL,
  LOADING,
  OK,
  ERROR,
}
